import { useEffect } from 'react';

/**
 * Matches Canva purchase: Inter stack, no legacy body SVG, white/html base.
 * Pair with a root `.canva-purchase-page` for the gradient shell.
 */
export function useCanvaEmbedDocument() {
  useEffect(() => {
    document.documentElement.classList.add('canva-purchase-html');
    document.body.classList.add('canva-purchase-body');
    const prevInlineBg = document.body.style.backgroundImage;
    document.body.style.backgroundImage = 'none';
    return () => {
      document.body.style.backgroundImage = prevInlineBg;
      document.documentElement.classList.remove('canva-purchase-html');
      document.body.classList.remove('canva-purchase-body');
    };
  }, []);
}
